export default __webpack_public_path__ + "files/0b9f976921bc77ed0ffcdf57161590b9.jpg";